import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AnketKonuListeAPI from "../../../apis/OB/Get/AnketKonuListeAPI";

const Anketlerim: React.FC = () => {
  const [anketKonuListe, setAnketKonuListe] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    AnketKonuListeAPI.getAnketKonuListe()
      .then((response) => {
        setAnketKonuListe(response.data);
      })
      .catch((error) => {
        console.error("API hatası:", error);
      });
  }, []);

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Anketlerimiz
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Lütfen katılmak istediğiniz anketi seçiniz
      </Typography>
      <hr className="mb-2" />
      {anketKonuListe.length > 0 ? (
        anketKonuListe.map((anket) => (
          <Card
            key={anket.konuId}
            onClick={() => {
              navigate(`/anketler/${anket.konuAdi.replaceAll(" ","-")}`, {
                state: { anket: anket},
              });
            }}
            className="mb-4"
          >
            <CardActionArea>
              <CardContent>
                <Typography variant="h5">{anket.konuAdi}</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))
      ) : (
        <Typography>
          Şu an anketimiz bulunmamaktadır. Göstermiş olduğunuz ilgi için
          teşekkür ederiz.
        </Typography>
      )}
    </Container>
  );
};

export default Anketlerim;
